import {DefaultSchema} from '@/schema/DefaultSchema'
import {FieldSet, FieldComponent} from '@simpli/meta-schema'
import * as Component from '@simpli/vue-input'
import {GithubRepository} from '@/model/resource/GithubRepository'
import {GithubOrganizationCollection} from '@/model/collection/GithubOrganizationCollection'
import InputColorHex from '@/components/input/InputColorHex.vue'

export class InputGithubRepositorySchema extends DefaultSchema {
  collectionGithubOrganization = new GithubOrganizationCollection().noPagination()

  readonly name = 'InputGithubRepository'

  readonly fieldSet: FieldSet<GithubRepository> = {
    organization: (schema): FieldComponent => ({
      is: Component.InputSelect,
      bind: {
        label: this.translateFrom(schema.fieldName),
        items: this.collectionGithubOrganization.items,
      },
    }),
    colorHex: (schema): FieldComponent => ({
      is: InputColorHex,
      bind: {
        label: this.translateFrom(schema.fieldName),
        required: true,
      },
    }),
    name: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 128,
        label: this.translateFrom(schema.fieldName),
        required: true,
        validation: 'required',
      },
    }),
    url: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 256,
        label: this.translateFrom(schema.fieldName),
        required: true,
        validation: 'required',
      },
    }),
    labelsTokenized: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 256,
        label: this.translateFrom(schema.fieldName),
        required: true,
        validation: 'required',
      },
    }),
    branch: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 255,
        label: this.translateFrom(schema.fieldName),
        required: true,
        validation: 'required',
      },
    }),
    description: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'textarea',
        label: this.translateFrom(schema.fieldName),
        maxlength: 600,
        row: 5,
        class: 'col-span-2',
      },
    }),
  }
}
